import { Component, EventEmitter, Input, OnInit, Optional, Output } from "@angular/core";
import { DialogRef } from "@progress/kendo-angular-dialog";
import { SendStateWithLogic } from "../../../models/request/send-state-with-logic";
import { RequestDeviceWarehouseRefillDto } from "../../../models/request/request-device-warehouse-refills";
import { RequestDeviceWarehouseRefillsService } from "../../../services/request-device-warehouse-refills.service";
import { RequestsService } from "../../../services/requests.service";
import { DevicesService } from "../../../services/devices.service";
import { SelectSn } from "../../../models/device/select-sn/select-sn.model";
import { SelectSnData } from "../../../models/device/select-sn/select-sn-data.model";
import { DeviceStatus } from "../../../enums/device-status.enum";
import { RequestStatus } from "../../../enums/request-status.enum";
import { ChangeStatusModel } from "../../../models/change-status-models/change-status-model";

@Component({
	selector: "internal-warehouse-transfer-acceptance",
	templateUrl: "./internal-warehouse-transfer-acceptance.component.html",
	styleUrls: [
		"./internal-warehouse-transfer-acceptance.component.scss",
		"../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss",
		"../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss"
	]
})
export class InternalWarehouseTransferAcceptanceComponent implements OnInit {
	@Input() requestId: number;
	@Output() onContinueEvent = new EventEmitter<void>();
	@Output() onCancelEvent = new EventEmitter<void>();

	public devices: RequestDeviceWarehouseRefillDto[] = [];
	public dataLoading = false;
	public dataSaving = false;

	private readonly rsReceived_fromUi = "rsReceived_fromUi";

	constructor(
		@Optional() public dialog: DialogRef,
		private requestDeviceWarehouseRefillsService: RequestDeviceWarehouseRefillsService,
		private requestsService: RequestsService,
		private devicesService: DevicesService
	) {}

	get cardHeight(): number {
		return window.innerHeight - 170;
	}

	ngOnInit(): void {
		this.loadDevices();
	}

	cancel(): void {
		this.onCancelEvent.emit();
		this.closeDialog();
	}

	continue(): void {
		if (this.dataSaving || this.dataLoading) {
			return;
		}

		this.dataSaving = true;
		this.requestsService.getById(this.requestId).subscribe(res => {
			var statusId = res && res.entity ? res.entity.statusId : null;
			if (statusId === RequestStatus.acceptionAtTheRecipientWarehouse) {
				this.acceptDevices();
				return;
			}

			var changeStatusModel = new ChangeStatusModel(
				this.requestId,
				RequestStatus.acceptionAtTheRecipientWarehouse);
			changeStatusModel.forceChangeStatus = true;

			this.requestsService.changeStatus(changeStatusModel).subscribe(changeResult => {
				if (!changeResult || !changeResult.isSuccessful) {
					this.dataSaving = false;
					return;
				}

				this.acceptDevices();
			}, () => {
				this.dataSaving = false;
			});
		}, () => {
			this.dataSaving = false;
		});
	}

	private acceptDevices(): void {
		this.devicesService.selectSn(new SelectSn(this.requestId, this.getSelectSnData(), false, true))
			.subscribe(selectSnResult => {
				if (!selectSnResult || !selectSnResult.isSuccessful) {
					this.dataSaving = false;
					return;
				}

				this.sendRsReceivedFromUi();
			}, () => {
				this.dataSaving = false;
			});
	}

	private sendRsReceivedFromUi(): void {
		this.requestsService.sendStateWithLogic(
			new SendStateWithLogic(this.requestId, this.rsReceived_fromUi))
			.subscribe(res => {
				this.dataSaving = false;
				if (res && res.isSuccessful) {
					this.onContinueEvent.emit();
					this.closeDialog();
				}
			}, () => {
				this.dataSaving = false;
			});
	}

	private getSelectSnData(): SelectSnData[] {
		return this.devices
			.filter(device =>
				device.deviceStatusId !== DeviceStatus.notFound
				&& device.deviceStatusId !== DeviceStatus.notConfirmedInEth)
			.map(device => new SelectSnData(
				device.requestDeviceWarehouseRefillId,
				device.selectedArticleNumber || device.articleNumber,
				DeviceStatus.acceptedAtTheRecipientWarehouse,
				device.isDevicePart,
				device.serialNumber,
				device.quantityReal || device.quantity || 1,
				device.recipientWarehouseCellNumber,
				null,
				false,
				device.nomenclature
			));
	}

	private loadDevices(): void {
		this.dataLoading = true;
		this.requestDeviceWarehouseRefillsService
			.getRequestDeviceWarehouseRefillsWithParts(this.requestId)
			.subscribe(result => {
				this.devices = result && result.data ? result.data : [];
				this.dataLoading = false;
			}, () => {
				this.dataLoading = false;
			});
	}

	private closeDialog(): void {
		if (this.dialog && this.dialog.close) {
			this.dialog.close();
		}
	}
}
